var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('LazyComponent',_vm._g(_vm._b({attrs:{"component-factory":_vm.componentFactory,"wrapper-class":_vm.wrapperClass}},'LazyComponent',_vm.$attrs,false),_vm.$listeners)):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }